export const LockIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.00073 11.5667C8.60088 11.5667 9.0874 11.0802 9.0874 10.48C9.0874 9.87986 8.60088 9.39334 8.00073 9.39334C7.40058 9.39334 6.91406 9.87986 6.91406 10.48C6.91406 11.0802 7.40058 11.5667 8.00073 11.5667Z"
                fill="#F6B51E"
            />
            <path
                d="M12.1873 6.35334V5.52C12.1873 3.72 11.754 1.33334 8.00065 1.33334C4.24732 1.33334 3.81398 3.72 3.81398 5.52V6.35334C1.94732 6.58667 1.33398 7.53334 1.33398 9.86V11.1C1.33398 13.8333 2.16732 14.6667 4.90065 14.6667H11.1007C13.834 14.6667 14.6673 13.8333 14.6673 11.1V9.86C14.6673 7.53334 14.054 6.58667 12.1873 6.35334ZM8.00065 12.4933C6.88732 12.4933 5.98732 11.5867 5.98732 10.48C5.98732 9.36667 6.89398 8.46667 8.00065 8.46667C9.10732 8.46667 10.014 9.37334 10.014 10.48C10.014 11.5933 9.11398 12.4933 8.00065 12.4933ZM4.90065 6.29334C4.84732 6.29334 4.80065 6.29334 4.74732 6.29334V5.52C4.74732 3.56667 5.30065 2.26667 8.00065 2.26667C10.7007 2.26667 11.254 3.56667 11.254 5.52V6.3C11.2007 6.3 11.154 6.3 11.1007 6.3H4.90065V6.29334Z"
                fill="#F6B51E"
            />
        </svg>
    );
};
